import { useCallback } from 'react';

import { useLocation } from 'react-router';

import { useNavigate } from '@change-corgi/core/react/router';
import { useTracking } from '@change-corgi/core/react/tracking';

import { useStarterDashboardV2PageData } from 'src/app/pages/starterDashboardV2/pageContext';
import { useVanityLinkModalContext } from 'src/app/pages/starterDashboardV2/shared/contexts';
import { useCurrentAuthenticatedUser } from 'src/app/shared/hooks/session';

export function useTriggerVanityLinkModal() {
	const {
		data: { petition },
	} = useStarterDashboardV2PageData();
	const track = useTracking();

	const user = useCurrentAuthenticatedUser();
	const navigate = useNavigate();
	const { pathname, search } = useLocation();
	const { openModal } = useVanityLinkModalContext();

	const triggerModal = useCallback(async () => {
		void track('custom_url_create_click', { num_signatures: petition.signatureState.signatureCount.displayed });

		if (!user) {
			const params = encodeURIComponent(`${pathname}${search}`);
			navigate(`/login_or_join?redirectTo=${params}`);
			return Promise.resolve();
		}

		openModal();

		return Promise.resolve();
	}, [track, navigate, pathname, petition, search, user, openModal]);

	return triggerModal;
}
